module.exports = __webpack_public_path__ + "img/zhInvite.a773532c.png";